import { actionTypes } from '../actions/websites';

// DEFAULT STATE
export const initWebsites = {
  websites: [],
  selectedWebsite: null,
  filterWebsite: {
    completed: 'n',
  },
  sortBy: 'createdDate',
  sortDir: 'asc',
  pageNum: 0,
};

// WRITES
const websites = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_WEBSITES:
      return Object.assign({}, state, {
        websites: action.value,
      });
    case actionTypes.SET_SELECTED_WEBSITE:
      return Object.assign({}, state, {
        selectedWebsite: action.value,
      });
    case actionTypes.SET_FILTER_WEBSITE:
      return Object.assign({}, state, {
        filterWebsite: action.value,
      });
    case actionTypes.SET_SORT_BY:
      return Object.assign({}, state, {
        sortBy: action.value,
      });
    case actionTypes.SET_SORT_DIR:
      return Object.assign({}, state, {
        sortDir: action.value,
      });
    case actionTypes.SET_PAGE_NUM:
        return Object.assign({}, state, {
          pageNum: action.value,
        });
    case actionTypes.SET_UPDATE_IN_PROGRESS:
        return Object.assign({}, state, {
          updateInProgress: true,
        });
    case actionTypes.SET_UPDATE_COMPLETE:
        return Object.assign({}, state, {
          updateInProgress: false,
        });
    case actionTypes.UPDATE_WEBSITE:
      const remainingWebsites = state.websites.filter(d => d.id !== action.value.id);
      const updatedWebsites = [action.value].concat(remainingWebsites);
      return {
        ...state,
        websites: updatedWebsites,
        selectedWebsite: action.value,
      };

    default:
      return state;
  }
};

// READS
export const getWebsites = (state) => state.websites.websites;
export const getSelectedWebsite = (state) => state.websites.selectedWebsite;
export const getFilterWebsite = (state) => state.websites.filterWebsite;
export const getSortBy = (state) => state.websites.sortBy;
export const getSortDir = (state) => state.websites.sortDir;
export const getPageNum = (state) => state.websites.pageNum;
export const getUpdateInProgress = (state) => state.websites.updateInProgress;

export default websites;
